"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionItemWrapper = exports.RecentSearchRemoveButton = exports.SuggestionsContainerClasses = exports.SearchButton = exports.SearchBarInnerWrapper = exports.SearchBarWrapper = void 0;
var merch_components_1 = require("@carvana/merch-components");
exports.SearchBarWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex h-44 w-full items-center p-0 m:h-56'
});
exports.SearchBarInnerWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex h-full flex-1 items-center overflow-hidden'
});
exports.SearchButton = (0, merch_components_1.createComponent)('button', {
    className: 'rounded bg-blue-2 p-8 text-white transition-colors tl-label-m hover:bg-blue-3 disabled:bg-grey-2'
});
exports.SuggestionsContainerClasses = 'absolute left-0 right-0 overflow-hidden bg-white';
exports.RecentSearchRemoveButton = (0, merch_components_1.createComponent)('button', {
    className: 'flex items-center justify-center bg-transparent text-grey-3 transition-colors hover:text-blue-6'
});
exports.SuggestionItemWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex cursor-pointer items-center gap-8 overflow-hidden text-ellipsis whitespace-nowrap px-8 py-[6px] text-left text-blue-6 text-blue-6 tl-body-m'
});
//# sourceMappingURL=SearchBar.styles.js.map